import React from "react";

import { IconProps } from "../../types/common";

const EditIcon = ({
  width = "24",
  height = "24",
  style,
  className,
  fillClassName,
  fillColor = "#63696F",
}: IconProps) => (
  <svg
    style={style}
    width={width}
    height={height}
    aria-hidden="true"
    viewBox="0 0 24 24"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill={fillColor!}
      className={fillClassName}
      d="M20.7 5.63a1 1 0 010 1.41l-1.82 1.83-3.75-3.75 1.83-1.83a1 1 0 011.4 0l2.35 2.34zM3 20.5v-3.04a.5.5 0 01.15-.36l10.9-10.9 3.76 3.74L6.89 20.85a.47.47 0 01-.35.15H3.5a.5.5 0 01-.5-.5z"
    />
  </svg>
);

export default EditIcon;
